export default __webpack_public_path__ + "static/media/rice_cake.bcd6ef69.jpg";